import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

export default makeStyles((theme) => ({
  whiteBody: {
    background: theme.palette.common.white,
  },
}));
